module.exports = __webpack_public_path__ + "static/media/slider_video.b354a438.mp4";